export type Lang = "pt" | "en";

export const t = {
  pt: {
    nav: {
      addToChrome: "Adicionar ao Chrome",
      download: "Baixar Helper",
      support: "Apoie o projeto",
    },
    hero: {
      badge: "Funciona no Teams, Discord, Slack e Zoom",
      headline: "Fique ativo.\nFique online.",
      sub: "MyLittleMouse move o mouse silenciosamente no nível do sistema operacional — seu status nunca mais vai aparecer como ausente.",
      cta: "Adicionar ao Chrome",
      ctaHelper: "Baixar Helper para Windows",
      note: "Gratuito • Sem cadastro",
    },
    how: {
      title: "Como funciona",
      steps: [
        { icon: "🧩", title: "Instale a extensão", desc: "Adicione o MyLittleMouse ao Chrome pela Web Store em segundos." },
        { icon: "⚙️", title: "Baixe o helper", desc: "Faça o download do helper para Windows e rode o install.bat uma única vez." },
        { icon: "__logo__", title: "Ative e esqueça", desc: "Clique no ícone, ative o toggle e ajuste o intervalo. Pronto." },
      ],
    },
    apps: {
      title: "Compatível com seus apps favoritos",
      sub: "Funciona tanto nas versões web quanto nos apps desktop.",
    },
    why: {
      title: "Por que o MyLittleMouse?",
      items: [
        { icon: "🖥️", title: "Funciona no desktop", desc: "Ao contrário de soluções que só funcionam no navegador, o MyLittleMouse age no OS — indistinguível de movimento humano para Teams e Discord." },
        { icon: "🔒", title: "100% local", desc: "Nenhum dado é enviado para servidores externos. Tudo roda na sua máquina." },
        { icon: "👁️", title: "Invisível", desc: "O movimento é de apenas 2px — imperceptível para você, suficiente para o sistema." },
        { icon: "⚡", title: "Leve e simples", desc: "Sem instaladores complexos, sem conta obrigatória. Instala em menos de 2 minutos." },
      ],
    },
    faq: {
      title: "Perguntas frequentes",
      items: [
        { q: "É seguro usar em meu computador?", a: "Sim. O MyLittleMouse não acessa nenhum dado do seu computador. Ele apenas move o mouse para evitar que o sistema detecte ociosidade." },
        { q: "Funciona com o Teams desktop?", a: "Sim. O Teams usa a API do Windows para detectar ociosidade. O helper age diretamente nessa API, então funciona com qualquer versão." },
        { q: "Preciso deixar o Chrome aberto?", a: "Sim, a extensão roda dentro do Chrome. O helper continua ativo enquanto o Chrome estiver aberto." },
        { q: "Como cancelo ou desativo?", a: "Clique no ícone da extensão e desative o toggle. O helper para imediatamente. Para desinstalar, rode o uninstall.bat." },
      ],
    },
    supportPage: {
      title: "Apoie o projeto",
      sub: "O MyLittleMouse é gratuito e construído por uma pessoa só. Se ele te ajudou, considere deixar uma contribuição — qualquer valor faz diferença.",
      tiers: [
        {
          amount: "R$2",
          role: "O Autobot",
          emoji: "🤖",
          desc: "Mais do que robôs disfarçados — você é um herói em campo. Com R$2, você respondeu ao chamado quando a Terra precisava. Roll out.",
          cta: "Contribuir com R$2",
          url: "https://buy.stripe.com/7sY4gzf5H7ka7XI7l42sM00",
        },
        {
          amount: "R$5",
          role: "O Mandaloriano",
          emoji: "🪖",
          desc: "Este é o caminho. Você não busca reconhecimento, não faz barulho — apenas age. Seu apoio é silencioso, mas poderoso. Din Djarin aprovaria.",
          cta: "Contribuir com R$5",
          url: "https://buy.stripe.com/14AdR9aPr47Ya5Q9tc2sM01",
        },
        {
          amount: "R$10",
          role: "O Mago",
          emoji: "🧙",
          desc: "Você não chega cedo nem tarde — chega exatamente quando deve. Com R$10, você ilumina o caminho para que esse projeto continue existindo. Você não passará... em branco.",
          cta: "Contribuir com R$10",
          url: "https://buy.stripe.com/9B66oHbTv6g6em6dJs2sM02",
        },
      ],
    },
    pixCard: {
      role: "O Cavaleiro das Trevas",
      desc: "Sem superpoderes. Apenas a decisão de fazer a diferença — assim como você. Você não precisava fazer isso, mas fez. Gotham agradece.",
      label: "Pague quanto quiser via PIX",
      hint: "Escaneie o QR Code com o app do seu banco",
    },
    footer: {
      rights: "Todos os direitos reservados.",
      privacy: "Privacidade",
      support: "Suporte",
    },
  },
  en: {
    nav: {
      addToChrome: "Add to Chrome",
      download: "Download Helper",
      support: "Support the project",
    },
    hero: {
      badge: "Works with Teams, Discord, Slack and Zoom",
      headline: "Stay active.\nStay online.",
      sub: "MyLittleMouse silently moves your mouse at the OS level — your status will never show as away again.",
      cta: "Add to Chrome",
      ctaHelper: "Download Helper for Windows",
      note: "Free • No sign-up required • Unlimited use",
    },
    how: {
      title: "How it works",
      steps: [
        { icon: "🧩", title: "Install the extension", desc: "Add MyLittleMouse to Chrome from the Web Store in seconds." },
        { icon: "⚙️", title: "Download the helper", desc: "Download the Windows helper and run install.bat just once." },
        { icon: "__logo__", title: "Enable and forget", desc: "Click the icon, toggle it on and set your interval. That's it." },
      ],
    },
    apps: {
      title: "Works with your favorite apps",
      sub: "Compatible with both web and desktop versions.",
    },
    why: {
      title: "Why MyLittleMouse?",
      items: [
        { icon: "🖥️", title: "Works on desktop apps", desc: "Unlike browser-only solutions, MyLittleMouse acts at the OS level — indistinguishable from real mouse movement for Teams and Discord." },
        { icon: "🔒", title: "100% local", desc: "No data is sent to external servers. Everything runs on your machine." },
        { icon: "👁️", title: "Invisible", desc: "The movement is only 2px — imperceptible to you, enough to fool the system." },
        { icon: "⚡", title: "Light and simple", desc: "No complex installers, no mandatory account. Up and running in under 2 minutes." },
      ],
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        { q: "Is it safe to use at work?", a: "Yes. MyLittleMouse does not access any company data. It only moves the mouse to prevent the system from detecting idle time." },
        { q: "Does it work with Teams desktop?", a: "Yes. Teams uses the Windows API to detect idle. The helper acts directly on that API, so it works with any version." },
        { q: "Do I need to keep Chrome open?", a: "Yes, the extension runs inside Chrome. The helper stays active as long as Chrome is open." },
        { q: "How do I disable or uninstall?", a: "Click the extension icon and toggle it off. The helper stops immediately. To uninstall, run uninstall.bat." },
      ],
    },
    supportPage: {
      title: "Support the project",
      sub: "MyLittleMouse is free and built by a single person. If it helped you, consider leaving a contribution — any amount makes a difference.",
      tiers: [
        {
          amount: "$1",
          role: "The Autobot",
          emoji: "🤖",
          desc: "More than meets the eye — you're a hero on the ground. With $1, you answered the call when it was needed. Roll out.",
          cta: "Contribute $1",
          url: "https://buy.stripe.com/7sY4gzf5H7ka7XI7l42sM00",
        },
        {
          amount: "$3",
          role: "The Mandalorian",
          emoji: "🪖",
          desc: "This is the way. You don't seek glory or recognition — you just act. Your support is quiet but powerful. Din Djarin would approve.",
          cta: "Contribute $3",
          url: "https://buy.stripe.com/14AdR9aPr47Ya5Q9tc2sM01",
        },
        {
          amount: "$5",
          role: "The Wizard",
          emoji: "🧙",
          desc: "You shall not pass... on a good project. You arrive exactly when you should, lighting the way for this project to keep going.",
          cta: "Contribute $5",
          url: "https://buy.stripe.com/9B66oHbTv6g6em6dJs2sM02",
        },
      ],
    },
    footer: {
      rights: "All rights reserved.",
      privacy: "Privacy",
      support: "Support",
    },
  },
};
